import { useState } from 'react';
import { HelpServices } from 'services/api/endpoints/learnMore';
import { SHelpSectionData } from '../types';

const useLearnMore = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<SHelpSectionData | null>(null);

  const fetchData = (screen: string) => {
    setIsLoading(true);
    HelpServices.fetchHelpSectionData(screen)
      .then((response) => {
        setData(response.data.data.body);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return { data, isLoading, fetchData };
};

export default useLearnMore;
